import { Badge } from '../../../components/ui/Badge';
import { Section } from '../../../components/ui/Section';
import { asRecord, str } from '../../../platform/api/utils';
import { TASK_ASSIGNMENT_STATUS_LABELS, labelOf } from '../../../shared/labels';
import { displayName, modalOverlay, secondaryBtn } from './task-detail.support';

// Aba Atribuídos do TaskDetail (régua de 400), incluindo o modal de atribuição;
// estado e mutações ficam na página.
export function TaskAssignTab(props: {
  assignments: unknown[];
  people: Record<string, unknown>[];
  assignOpen: boolean;
  personSearch: string;
  onOpenAssign: () => void;
  onClose: () => void;
  onPersonSearchChange: (value: string) => void;
  onAssign: (personId: string) => void;
  onUnassign: (assignmentId: string) => void;
  unassigning: boolean;
}) {
  const {
    assignments,
    people,
    assignOpen,
    personSearch,
    onOpenAssign,
    onClose,
    onPersonSearchChange,
    onAssign,
    onUnassign,
    unassigning,
  } = props;
  return (
    <Section
      title="Pessoas atribuídas"

      action={
        <button
          type="button"
          onClick={() => {
            onOpenAssign();
          }}
          style={secondaryBtn}
        >
          + Atribuir
        </button>
      }
    >
      {assignments.length === 0 ? (
        <p style={{ color: 'var(--faint)', fontSize: '0.875rem' }}>
          Nenhuma pessoa atribuída a esta tarefa.
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {assignments.map((raw) => {
            const a = asRecord(raw);

            const person = asRecord(a.person);

            return (
              <div
                key={str(a.id)}

                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',

                  padding: '0.5rem 0.75rem',
                  background: 'var(--paper)',
                  borderRadius: 10,

                  border: '1px solid var(--line-soft)',
                }}
              >
                <div>
                  <span style={{ fontWeight: 500, fontSize: '0.85rem' }}>
                    {displayName(person)}
                  </span>

                  {a.isPrimary ? <Badge label="Principal" variant="info" /> : null}

                  {str(person.religiousName) && (
                    <span
                      style={{
                        fontSize: '0.75rem',
                        color: 'var(--faint)',
                        marginLeft: '0.5rem',
                        fontStyle: 'italic',
                      }}
                    >
                      {str(person.religiousName)}
                    </span>
                  )}

                  <div style={{ marginTop: 4 }}>
                    <Badge
                      label={labelOf(TASK_ASSIGNMENT_STATUS_LABELS, a.status, 'Designada')}

                      variant={
                        str(a.status) === 'DONE'
                          ? 'success'
                          : str(a.status) === 'DECLINED'
                            ? 'danger'
                            : 'default'
                      }
                    />
                  </div>
                </div>

                <button
                  type="button"

                  onClick={() => {
                    onUnassign(str(a.id));
                  }}

                  disabled={unassigning}

                  style={{
                    background: 'none',
                    border: '1px solid var(--danger-soft)',
                    color: 'var(--danger)',

                    borderRadius: 8,
                    padding: '0.2rem 0.5rem',
                    fontSize: '0.75rem',
                    cursor: 'pointer',
                  }}
                >
                  Remover
                </button>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal: Atribuir pessoa */}

      {assignOpen && (
        <div
          style={modalOverlay}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              onClose();
            }
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 14,
              padding: '1.5rem',
              minWidth: 380,
              maxWidth: 460,
            }}
          >
            <h3 style={{ margin: '0 0 0.75rem', fontSize: '1rem' }}>Atribuir pessoa</h3>

            <input
              type="text"

              placeholder="Buscar pessoa..."

              value={personSearch}

              onChange={(e) => {
                onPersonSearchChange(e.target.value);
              }}

              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid var(--line)',
                borderRadius: 10,
                fontSize: '0.85rem',
                marginBottom: '0.75rem',
                boxSizing: 'border-box',
              }}

              autoFocus
            />

            <div style={{ maxHeight: 200, overflow: 'auto', marginBottom: '0.75rem' }}>
              {people
                .filter(
                  (p) =>
                    !assignments.some((a) => {
                      const ap = asRecord(a).person as Record<string, unknown> | undefined;

                      return ap && ap.id === p.id;
                    }),
                )
                .map((p) => (
                  <div
                    key={str(p.id)}

                    onClick={() => {
                      onAssign(str(p.id));
                    }}

                    style={{
                      padding: '0.5rem 0.75rem',
                      cursor: 'pointer',
                      borderRadius: 8,

                      fontSize: '0.85rem',
                      transition: 'background 0.1s',
                    }}
                  >
                    <span style={{ fontWeight: 500 }}>{displayName(p)}</span>

                    {str(p.religiousName) && (
                      <span
                        style={{
                          fontSize: '0.75rem',
                          color: 'var(--faint)',
                          marginLeft: '0.5rem',
                          fontStyle: 'italic',
                        }}
                      >
                        {str(p.religiousName)}
                      </span>
                    )}
                  </div>
                ))}

              {people.length === 0 && (
                <p
                  style={{
                    color: 'var(--faint)',
                    fontSize: '0.85rem',
                    textAlign: 'center',
                    padding: '1rem',
                  }}
                >
                  {personSearch ? 'Nenhuma pessoa encontrada.' : 'Digite para buscar pessoas.'}
                </p>
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={() => {
                  onClose();
                }}
                style={secondaryBtn}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </Section>
  );
}
